export default __webpack_public_path__ + "static/media/pic5.d1a875b9.jpg";